import { render, staticRenderFns } from "./ImportDetailsList.vue?vue&type=template&id=2babbeb4&scoped=true"
import script from "./ImportDetailsList.vue?vue&type=script&lang=js"
export * from "./ImportDetailsList.vue?vue&type=script&lang=js"
import style0 from "./ImportDetailsList.vue?vue&type=style&index=0&id=2babbeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2babbeb4",
  null
  
)

export default component.exports